import React from 'react';

import {
    Cards,
    CardsPropertyFiltering,
    Button,
    CardsPagination, AppLayout,
    Tabs
} from 'AWS-UI-Components-React';
import {JSClient} from "./common";
import Navigation from './navigation';
import {SearchCard} from "./cards/search_card";

const items = [
    {
        "name": "ON-Hold invoices for  Payee Code: HARD4",
        "period": 1,
        "search_link": "https://finopscentral-eu.amazon.com/invoice/search?search_key=oahtgrzcmuklwxf",
        "user": "ritish",
        "uuid": "1"
    }, {
        "name": "ON-Hold invoices for  Payee Code: JUMF5",
        "period": 7,
        "search_link": "https://finopscentral-eu.amazon.com/invoice/search?search_key=hrapcoxnmjdbltu",
        "user": "ritish",
        "uuid": "2"
    }
];

const tabs = [
    {
        "label": "Saved",
        "id": "first",
        "content": <SearchCard/>
    }
];

const Content = () => (<div className='awsui-grid awsui-util-p-s'>
    <div className='custom-home__header custom-awsui-util-pt-xxxl awsui-row'>
        <div className='col-xxs-12'>
            <div className='awsui-row'>
                <div
                    className='custom-home__header-title col-xxs-10 offset-xxs-1 col-s-10 col-l-11 offset-l-1 col-xl-10'>
                    <div className='awsui-text-large'>
                        <div><strong>Searches</strong></div>
                    </div>

                    <div className='beersTable'>
                        <Tabs tabs={tabs} activeTabId="first"></Tabs>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>);

export class Reports extends React.Component {

    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
searches:[]
        };
        this.clientLoaded = this.clientLoaded.bind(this);
        this.getSearchesResultHandler = this.getSearchesResultHandler.bind(this);
    }

    clientLoaded() {
        this.client.getIdentity(identityResult => {
            this.setState({...this.state, user: identityResult.username, initialLoadDone: true});
            this.client.getSearches({
                type: this.state.type,
                user: this.state.user, ...this.props
            }, this.getSearchesResultHandler);
        });
    }

    componentWillMount() {
        this.client = new JSClient({onReady: this.clientLoaded});
    }
    getSearchesResultHandler(searchResult) {
        this.setState({searches: searchResult.searches, searchLoadDone: true});
    }

    render() {
        return (
            <div className="awsui">
                <AppLayout
                    className='awsui-util-no-gutters'
                    content={<Content />}
                    navigation={<Navigation activeHref="#/"/>}
                    navigationOpen={true}
                    toolsHide={false}
                />
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/reports.jsx